<mat-card-title>
    {{errorHeader}}
</mat-card-title>
<mat-divider class="mat-divider-inherit-with-margin"></mat-divider>
<mat-card-subtitle>{{errorMessage}}</mat-card-subtitle>
<p *ngIf="showPhone">You can call our office at <a href='tel:+1-844-997-3624' i18n i18n-href>844-997-3624</a> for immediate assistance.</p>
